import * as React from 'react';
import * as Styled from './RadioButtons.styled';
import RadioButton from './RadioButton';

interface Option extends ReactFCWithChildren {
  RadioButtonGroup: typeof Styled.WrapperGroup;
  RadioButton: typeof RadioButton;
}

const RadioButtons: Option = (props) => <React.Fragment>{props.children}</React.Fragment>;

RadioButtons.RadioButtonGroup = Styled.WrapperGroup;
RadioButtons.RadioButton = RadioButton;

export default RadioButtons;
